import i18n from 'i18next';

export function getAppLocale(): string {
    return i18n.language || navigator.language;
}

export function getDateTime(dateTime: Date) {
    const locale = getAppLocale();
    return new Date(dateTime).toLocaleString(locale);
}

export function getDateTimeFromNumber(dateTime: number | Date) {
    const locale = getAppLocale();
    return new Date(dateTime).toLocaleString(locale);
}

export function getTime(dateTime: Date) {
    const locale = getAppLocale();
    return new Date(dateTime).toLocaleTimeString(locale);
}
